import type { RenderedMenuItem } from '@/types/menu.type';
import { create } from 'zustand';

interface MenuState {
  menuItems: RenderedMenuItem[];
  menuPathMap: Map<string, RenderedMenuItem>;
  setMenuItems: (menuItems: RenderedMenuItem[]) => void;
  setMenuPathMap: (menuPathMap: Map<string, RenderedMenuItem>) => void;
  setMenuState: (
    menuItems: RenderedMenuItem[],
    menuPathMap: Map<string, RenderedMenuItem>
  ) => void;
}

export const useMenuStore = create<MenuState>((set) => ({
  menuItems: [],
  menuPathMap: new Map(),
  setMenuItems: (menuItems) => set({ menuItems }),
  setMenuPathMap: (menuPathMap) => set({ menuPathMap }),
  setMenuState: (menuItems, menuPathMap) => {
    set({ menuItems });
    set({ menuPathMap });
  },
}));
